import {Component, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {catchError, map, take} from "rxjs/operators";
import {ICartCreate, IUser} from "../../../interfaces";
import {dateToday, dateUnixToString} from "../../../common";
import {actionLoadCartContentRequest, actionLoadCartProductRequest} from "../../../store/actions/user.actions";
import {TranslocoService} from "@ngneat/transloco";
import {LocalStoreService} from "../../../services/local-store.service";
import {UserService} from "../../../services/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {StoreSelectorsService} from "../../../services";
import {Compbaser} from "../../../components/compbaser";
import {ToastrService} from "ngx-toastr";
import {ChildrenOutletContexts} from '@angular/router';
import {Memoizee} from "../../../decorators/memoizee-decorator";

@Component({
    selector: 'app-shopping-entry',
    templateUrl: './shopping-entry.component.html',
    styleUrls: ['./shopping-entry.component.css'],
    animations: [
        trigger('fadeIn', [
            transition('* => *', [
                style({opacity: 0}),
                animate('300ms ease-in-out')
            ])
        ])
    ]
})
export class ShoppingEntryComponent extends Compbaser implements OnInit {

    cartCreate: ICartCreate;
    user: IUser;

    constructor(private translocoService: TranslocoService, private localStoreService: LocalStoreService, private userService: UserService,
                private router: Router, private route: ActivatedRoute, private storeSelector: StoreSelectorsService, private toastr: ToastrService,
                private contexts: ChildrenOutletContexts) {
        super();

        if (this.router.url.indexOf('charge') > -1) {
            const parts = this.router.url.split('/');
            const orderId = parts[parts.length - 1].split(':').shift();
            const cartCreate: ICartCreate = {orderId, time: dateToday('MM-DD-YYYY')};
            this.initCart(cartCreate);
        } else {
            this.initCart();
        }

        this.cod(
            this.storeSelector.getUser().subscribe((user) => this.user = user)
        );
    }

    ngOnInit(): void {
    }

    @Memoizee({})
    getState() {
      return this.contexts.getContext('primary')?.route?.snapshot?.data?.['state'];
    }

    getCartContent() {
        this.storeSelector.dispatch(actionLoadCartContentRequest({
            cartRequest: {
                serverCall: "GET_CART_CONTENT",
                cartCreate: this.cartCreate,
                user: this?.user?.username,
                password: this?.user?.passwordNew
            }
        }));
    }

    initCart(i_cartCreate?: ICartCreate) {
        if (i_cartCreate) {
            this.cartCreate = i_cartCreate;
            this.localStoreService.initCartCreate(i_cartCreate);
        } else {
            this.cartCreate = this.localStoreService.getCartCreate();
        }
        if (this.cartCreate) {
            this.getCartContent();
        } else {
            this.createCartId();
        }
    }

    createCartId() {
        this.cod(
            this.userService.getCartCreate()
                .pipe(take(1),
                    map((r: ICartCreate) => {
                        r.time = dateUnixToString(String(r.time), -3, 'MM-DD-YYYY');
                        return r;
                    }),
                    catchError(e => {
                        this.toastr.error(this.translocoService.translate('toast.problemGettingCartInfo', {}, this.translocoService.getActiveLang()));
                        return e;
                    }))
                .subscribe((r: ICartCreate) => {
                    this.localStoreService.initCartCreate(r);
                    this.cartCreate = r;
                    this.getCartContent();
                })
        );
    }
}

// this.cod(
//     this.route.data.subscribe((v) => {
//         if (v.state === 'chargeMode'){
//             this.chargeMode = true;
//         }
//     })
// );
// this.cod(
//     this.route.paramMap.subscribe((routeParams) => {
//         if (this.chargeMode) {
//             const param: string = routeParams.get('order_id');
//             if (!param) return;
//             const orderId = param.split(':')[0];
//             alert('initCartCreate 1 ' + orderId);
//         }
//
//         // const v: string = routeParams.get('custom_id');
//         // if (v) {
//         //     const orderId = v.split(':')[0];
//         //     const time = dateToday('MM-DD-YYYY');
//         //     if (orderId.length > 50) {
//         //         const r: ICartCreate = {time, orderId};
//         //         this.localStoreService.initCartCreate(r);
//         //         /** load encrypted order id to cart for charge link **/
//         //         // this.localStoreService.// swap the order
//         //     }
//         // }
//     })
// );
// alert('not good');


// checkCustomProductUrl() {
//     this.cod(
//         this.route.paramMap
//             .pipe(take(1))
//             .subscribe((routeParams) => {
//                 if (routeParams.get('custom_id')) {
//                     const v: string = routeParams.get('custom_id');
//                     const price = v.split(':')[1];
//                     const product: ICartProduct = {
//                         product_id: MS_15,
//                         name: 'MS-15 Digital Signage product',
//                         description: 'custom products',
//                         price,
//                         product_count: 1,
//                         shipping_points: 0,
//                         stock: '1',
//                         cost: '0',
//                         discount: '0',
//                         active: '1'
//                     };
//                     this.addToCartCustom(product);
//                 }
//             })
//     );
// }


// addToCartCustom(product: ICartProduct) {
//     this.router.navigate([`/shopping-cart/list/${product.product_id}:${product.price}:${_.uniqueId()}`], {relativeTo: this.route});
// }
